import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from "assets/common/logo.svg";
import { ReactComponent as LogoSolomon } from "assets/common/logoSolomon.svg";
import { ReactComponent as Down } from "assets/header/down.svg";
import { ReactComponent as Menu } from "assets/common/menu.svg";
import { ReactComponent as Pulse } from "assets/header/pulseonship.svg";
import { ReactComponent as PulseMo } from "assets/header/pulseonMo.svg";
import { ReactComponent as Solomon } from "assets/header/solomonship.svg";
import { ReactComponent as SolomonMo } from "assets/header/solomonMo.svg";
import './style.css'
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import { checkCompanyCodeAtom, useGetUser, userAtom } from 'atom/user';
import { IMenu, menu, profileMenu } from './menu';
import CustomButton from 'components/common/CustomButton';
import { AnimatePresence, motion } from 'framer-motion';
import { useSetAtom } from 'jotai';
import { GlobalContext } from 'App';
import { toast } from 'react-toastify';
import { encrypt } from 'components/encryptDecrpt';

interface IHeader {
    isHeaderChange?: boolean
    isOverLay?: boolean
}

const Header = ({ isHeaderChange, isOverLay }: IHeader) => {
    const { isTablet } = useContext(GlobalContext);
    const originName = window.location.origin;
    const pathname = window.location.pathname;
    const setCheckCompany = useSetAtom(checkCompanyCodeAtom);
    const user = useGetUser();
    const setUser = useSetAtom(userAtom)
    const navigate = useNavigate();
    const [menuState, setMenuState] = useState<IMenu[]>([]);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [unreadNotification, setUnreadNotification] = useState<boolean>(false);
    const [isSolomon, setIsSolomon] = useState<boolean>(false);
    const [isDev, setIsDev] = useState<boolean>(false);

    useEffect(() => {
        if (originName.includes('pulseonship')) {
            setIsDev(false)
        }
        else {
            setIsDev(true)
        }

        if (pathname.includes('solomon')) {
            setIsSolomon(true)
        }
    }, [pathname, originName])

    useEffect(() => {
        // 조건에 맞는 메뉴 계산
        const filteredMenu =
            user.id && user.useSolomon
                ? menu
                : menu.filter((m) => !["solomonShip"].includes(m.titleEn));

        setMenuState(filteredMenu);
    }, [user.id, user.useSolomon]);

    useEffect(() => {
        getNotiCheck();

        setTimeout(() => {
            setIsLoading(false)
        })
    }, [user.id])

    const getNotiCheck = () => {
        if (!user.id) return
        jsonAxios.get('notification/check').then(res => {
            if (res.data.code === 200) {
                setUnreadNotification(res.data.data.unreadNotification)
            }
        })
    }

    const goMenu = (url: string, idx: number = 0) => {
        if (!url) {
            setMenuState(prev =>
                prev.map((menu, i) =>
                    i === idx && menu.subMenu
                        ? { ...menu, subMenuOpen: !menu.subMenuOpen }
                        : menu
                )
            );
            return;
        }
        else if ((url.includes('transport') ||
            url.includes('quote') ||
            url.includes('special')) &&
            user.id &&
            !user?.companyInfo?.companyFileInfo.fileName) {
            setCheckCompany(true)
            return
        }
        else if (url.includes('special') && user.id) {
            jsonAxios.get('user/info').then(res => {
                if (res.data.code === 200) {
                    const serUser = res.data.data
                    setUser(encrypt(JSON.stringify(res.data.data)))
                    if (serUser.isVIP) {
                        navigate(url);
                        setMenuOpen(false)
                        return
                    }
                    else {
                        toast.error('해당 메뉴 이용 권한이 없습니다. 자세한 내용은 1:1 문의 주시기 바랍니다.')
                        return;
                    }
                }
            })
        }
        else {
            navigate(url);
            setMenuOpen(false)
        }
    }

    const goLogin = () => {
        navigate('/login');
    }

    const goSignUp = () => {
        navigate('/signup');
    }

    return (
        <>
            <header
                className={`h-16 border-b-1 border-b-[#525252] fixed w-full z-50 backdrop-blur-lg text-[#A4A4A4] ${isHeaderChange ? 'bg-transparent' : isDev ? 'bg-[#1a3a76]' : 'bg-[#222222]'} mobile:h-16`}>
                {
                    isDev &&
                    <div className='left-0 absolute font-semibold text-red text-3xl'>
                        개발
                    </div>
                }
                <Container className='relative flex justify-between items-center h-full'>
                    <div className='flex items-center gap-10'>
                        <div
                            className='cursor-pointer'
                            onClick={() => goMenu(isSolomon ? '/solomonShip' : '/')}
                        >
                            {
                                isSolomon ?
                                    <LogoSolomon /> :
                                    <Logo />
                            }
                        </div>
                        {
                            !isSolomon &&
                            <ul className='hidden lg:flex gap-6'>
                                {
                                    menuState.map((item, idx) => (
                                        <li
                                            key={idx}
                                            onMouseEnter={() => setHoveredIndex(idx)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                            onClick={() => goMenu(item.url, idx)}
                                            className={`relative flex items-center justify-center h-16 cursor-pointer text-sm font-semibold hover:text-white transition-all gap-1 group
                                    ${pathname.includes(item.titleEn) ? 'text-white' : 'text-[#A4A4A4]'}`}>
                                            {item.title}
                                            {
                                                item.subMenu && item.subMenu.length > 0 &&
                                                <Down fill={(hoveredIndex === idx || pathname.includes(item.titleEn)) ? '#FFFFFF' : '#A4A4A4'} />
                                            }
                                            <AnimatePresence>
                                                {item.subMenu && item.subMenu.length > 0 && hoveredIndex === idx && (
                                                    <div className="top-[100%] left-[50%] z-20 absolute translate-x-[-50%]">
                                                        <motion.ul
                                                            className='bg-[#222222] border border-[#494A58] rounded-lg w-[140px] font-semibold'
                                                            initial={{ opacity: 0, y: -10 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            exit={{ opacity: 0, y: -10 }}
                                                            transition={{ duration: 0.2 }}
                                                        >
                                                            {item.subMenu.map((subItem, subIdx) => (
                                                                <li
                                                                    key={subIdx}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        goMenu(subItem.url)
                                                                    }}
                                                                    className={`cursor-pointer text-sm text-center text-[#A4A4A4] hover:bg-primary hover:text-white transition-all p-4
                                                                    ${subIdx === 0 && 'rounded-t-lg'}
                                                                    ${subIdx === (item.subMenu && item.subMenu.length - 1) && 'rounded-b-lg'}`}
                                                                >
                                                                    {subItem.title}
                                                                </li>
                                                            ))}
                                                        </motion.ul>
                                                    </div>
                                                )}
                                            </AnimatePresence>
                                        </li>
                                    ))
                                }
                            </ul>
                        }
                    </div>

                    {
                        !isLoading &&
                        <div className='flex items-center gap-4 mobile:gap-2 h-full text-white'>
                            {
                                user.id &&
                                user.useSolomon &&
                                <>
                                    {
                                        isSolomon ?
                                            <div
                                                className="flex justify-center items-center h-8 lg:hover:scale-105 transition-all cursor-pointer"
                                                onClick={() => goMenu('/')}
                                            >
                                                {
                                                    isTablet ?
                                                        <div className='flex justify-center items-center bg-gradient-to-r from-[#FF00E5] to-[#02DFDF] rounded-full w-8 h-8'>
                                                            <PulseMo />
                                                        </div>
                                                        :
                                                        <Pulse />
                                                }
                                            </div> :
                                            <div
                                                className="flex justify-center items-center lg:hover:scale-105 transition-all cursor-pointer"
                                                onClick={() => {
                                                    isDev ? navigate('/solomonShip') : toast.info('해당기능은 준비중입니다.')
                                                }}
                                            >
                                                {
                                                    isTablet ?
                                                        <div className='flex justify-center items-center bg-gradient-to-r from-[#A6FF00] to-[#00A349] rounded-full w-8 h-8'>
                                                            <SolomonMo />
                                                        </div>
                                                        :
                                                        <Solomon />
                                                }
                                            </div>
                                    }
                                </>
                            }
                            {
                                user.id &&
                                !isSolomon &&
                                <div className='lg:hidden relative flex items-center gap-3 h-full'>
                                    <Menu
                                        onClick={() => {
                                            setMenuOpen(p => !p)
                                        }} />

                                    {/* 서브 메뉴 */}
                                    <AnimatePresence>
                                        {menuOpen && (
                                            <div
                                                className="top-[101%] right-0 z-20 fixed w-full h-dvh"
                                                onClick={() => {
                                                    setMenuOpen(p => !p)
                                                }}
                                            >
                                                <div className='flex justify-end px-10 mobile:px-4 container'>
                                                    <motion.ul
                                                        className='bg-[#222222] border border-[#494A58] rounded-lg w-[170px] font-semibold'
                                                        initial={{ opacity: 0, y: -10 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        exit={{ opacity: 0, y: -10 }}
                                                        transition={{ duration: 0.2 }}
                                                    >
                                                        {
                                                            menuState.map((item, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        goMenu(item.url)
                                                                    }}
                                                                    className={`flex flex-col items-center justify-center cursor-pointer text-sm text-center text-[#A4A4A4] p-4 gap-4
                                                        ${idx === 0 && 'rounded-t-lg'}
                                                        ${idx === profileMenu.length - 1 && 'rounded-b-lg'}`}
                                                                >
                                                                    <div className='flex gap-1'>
                                                                        {item.title}
                                                                        {
                                                                            item.subMenu && item.subMenu.length > 0 &&
                                                                            <Down fill={pathname.includes(item.titleEn) ? '#FFFFFF' : '#A4A4A4'} />
                                                                        }
                                                                    </div>
                                                                    <AnimatePresence>
                                                                        {
                                                                            item.subMenuOpen &&
                                                                            item.subMenu &&

                                                                            item.subMenu.length > 0 && (
                                                                                <div className="">
                                                                                    <motion.ul
                                                                                        className='bg-[#222222] border border-[#494A58] rounded-lg w-[140px] font-semibold'
                                                                                        initial={{ opacity: 0, height: 0 }}
                                                                                        animate={{ opacity: 1, height: 168 }}
                                                                                        exit={{ opacity: 0, height: 0 }}
                                                                                        transition={{ duration: 0.2 }}
                                                                                    >
                                                                                        {item.subMenu.map((subItem, subIdx) => (
                                                                                            <li
                                                                                                key={subIdx}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    goMenu(subItem.url)
                                                                                                }}
                                                                                                className={`cursor-pointer text-sm text-center text-[#A4A4A4]transition-all p-4
                                                        ${subIdx === 0 && 'rounded-t-lg'}
                                                        ${subIdx === (item.subMenu && item.subMenu.length - 1) && 'rounded-b-lg'}`}
                                                                                            >
                                                                                                {subItem.title}
                                                                                            </li>
                                                                                        ))}
                                                                                    </motion.ul>
                                                                                </div>
                                                                            )}
                                                                    </AnimatePresence>
                                                                </li>
                                                            ))
                                                        }
                                                    </motion.ul>
                                                </div>
                                            </div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            }
                            {
                                user.id ?
                                    <div className='relative flex items-center gap-3 text-sm'>
                                        <div
                                            className='relative hover:bg-[#303030] p-1 rounded transition-all cursor-pointer'
                                            onClick={() => {
                                                navigate('/mypage/editProfile')
                                            }}
                                        >
                                            {
                                                unreadNotification &&
                                                <div className='top-2 right-2 absolute bg-red rounded-full w-2 h-2 translate-x-[25%] translate-y-[-25%]'></div>
                                            }
                                            <p>{user.companyInfo.companyNameKr}</p>
                                            <p className='mobile:hidden text-[#9D9EB7]'>{user.username}</p>
                                        </div>
                                    </div> :
                                    <div className='flex justify-center items-center gap-3 h-full'>
                                        <CustomButton
                                            onClick={goLogin}
                                            className='!px-0 !py-0 w-[100px] min-w-[100px] !h-10 font-normal'
                                            title='로그인'
                                        />
                                        <CustomButton
                                            onClick={goSignUp}
                                            className='bg-primary !px-0 mobile:!px-3 !py-0 w-[100px] min-w-[100px] !h-10 font-normal'
                                            title='회원가입'
                                        />
                                    </div>
                            }
                        </div>
                    }
                </Container>
            </header>
            {/* <div className='top-0 left-0 z-50 absolute bg-[rgba(0,0,0,0.5)] w-full h-full'></div> */}
            {
                !isOverLay &&
                <div className='h-16 mobile:h-16'></div>
            }
        </>
    );
}

export default Header;